var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "task-config-container" }, [
    _c(
      "div",
      { staticClass: "list-container" },
      [
        _c(
          "el-form",
          {
            staticClass: "compact-search-form",
            attrs: { inline: true, model: _vm.searchForm },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "" } },
              [
                _c("el-input", {
                  staticStyle: { width: "220px" },
                  attrs: { placeholder: "活动名称", clearable: "" },
                  model: {
                    value: _vm.searchForm.keywords,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "keywords", $$v)
                    },
                    expression: "searchForm.keywords",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "" } },
              [
                _c("el-date-picker", {
                  attrs: {
                    type: "datetimerange",
                    "range-separator": "至",
                    "start-placeholder": "开始日期",
                    "end-placeholder": "结束日期",
                    "value-format": "yyyy-MM-dd HH:mm:ss",
                  },
                  on: { change: _vm.changeTime },
                  model: {
                    value: _vm.times,
                    callback: function ($$v) {
                      _vm.times = $$v
                    },
                    expression: "times",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { staticClass: "form-actions" },
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.fetchList } },
                  [_vm._v("查询")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.addAct } },
                  [_vm._v("添加活动")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData,
              stripe: "",
              border: "",
              "element-loading-text": "数据加载中...",
              "element-loading-spinner": "el-icon-loading",
            },
          },
          [
            _c("el-table-column", {
              attrs: { prop: "id", label: "ID", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "activityName",
                label: "活动名称",
                align: "center",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "活动标题",
                prop: "activityTitle",
                align: "center",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "封面图", prop: "coverImage", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("el-image", {
                        staticStyle: { width: "60px", height: "60px" },
                        attrs: { src: scope.row.coverImage, fit: "cover" },
                      }),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "兑换码数量",
                prop: "exchangeTotalCount",
                align: "center",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "已兑换数量",
                prop: "exchangedCount",
                align: "center",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "活动时间",
                prop: "",
                align: "center",
                width: "300",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        _vm._s(scope.row.startTime) +
                          " - " +
                          _vm._s(scope.row.endTime)
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "门店", prop: "isStoreMode", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.isStoreMode === 0
                        ? _c("div", [_vm._v("不按门店")])
                        : _vm._e(),
                      _vm._v(" "),
                      scope.row.isStoreMode === 2
                        ? _c("div", [_vm._v("全部门店")])
                        : _vm._e(),
                      _vm._v(" "),
                      scope.row.isStoreMode === 1
                        ? _c("div", [_vm._v("部分门店")])
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "活动状态", prop: "status", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("el-switch", {
                        attrs: { "active-value": 1, "inactive-value": 0 },
                        on: {
                          change: function ($event) {
                            return _vm.changeStatus(
                              scope.row.id,
                              scope.row.status
                            )
                          },
                        },
                        model: {
                          value: scope.row.status,
                          callback: function ($$v) {
                            _vm.$set(scope.row, "status", $$v)
                          },
                          expression: "scope.row.status",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "操作",
                align: "center",
                fixed: "right",
                width: "250",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleEdit(scope.row)
                                },
                              },
                            },
                            [_vm._v("编辑")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleCopy(scope.row)
                                },
                              },
                            },
                            [_vm._v("复制")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.showCode(scope.row)
                                },
                              },
                            },
                            [_vm._v("二维码")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { "margin-top": "5px" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.detailUser(scope.row)
                                },
                              },
                            },
                            [_vm._v("兑换码")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleCoupon(scope.row)
                                },
                              },
                            },
                            [_vm._v("优惠券")]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pagination-container" },
          [
            _c("el-pagination", {
              attrs: {
                background: "",
                layout: "total, sizes, prev, pager, next, jumper",
                "current-page": _vm.searchForm.page,
                "page-sizes": [10, 20, 30, 50],
                "page-size": _vm.searchForm.limit,
                total: _vm.searchForm.total,
              },
              on: {
                "current-change": _vm.handlePageChange,
                "size-change": _vm.handleSizeChange,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: {
              visible: _vm.qrDialogVisible,
              width: "560px",
              "before-close": function () {
                return (_vm.qrDialogVisible = false)
              },
              center: "",
            },
            on: {
              "update:visible": function ($event) {
                _vm.qrDialogVisible = $event
              },
            },
          },
          [
            _c(
              "div",
              { staticStyle: { "text-align": "center", padding: "10px 0" } },
              [
                _vm.qrImage
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-bottom": "18px",
                          "font-size": "24px",
                          "font-weight": "bold",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.qrObj.activityName) + "\n                "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.qrImage
                  ? _c("el-image", {
                      staticStyle: {
                        "max-width": "320px",
                        "max-height": "320px",
                      },
                      attrs: { src: _vm.qrImage, fit: "contain" },
                    })
                  : _c("div", [_vm._v("暂无二维码图片")]),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }